import { lazy } from "react";

// Gestor de asignaciones paciente → agente del call center (módulo 30,
// moduleKey `call_assignments`). Conectado al backend real
// /api/CallAssignments; el agente ve su cola en el dashboard Call Center del
// Main. El flag se conserva por si hay que ocultarlo: en false se exporta [] y
// la ruta no se monta.
const CALL_ASSIGNMENTS_ENABLED = true;

const CallAssignmentsPage = lazy(() => import("./pages/CallAssignmentsPage"));

// El Contact Report cuelga del path del gestor a propósito:
// roleRoutePermissions resuelve el moduleKey por PREFIJO, así que
// /call-assignments/contact-report queda gobernado por `call_assignments` sin
// tocar el mapa RBAC. Una ruta hermana quedaría abierta hasta que alguien se
// acuerde de mapearla.
const ContactReportPage = lazy(() => import("./pages/ContactReportPage"));

export const callAssignmentsRoutes = CALL_ASSIGNMENTS_ENABLED
  ? [
      { path: "/call-assignments", element: <CallAssignmentsPage /> },
      { path: "/call-assignments/contact-report", element: <ContactReportPage /> },
    ]
  : [];
